module.exports = __webpack_public_path__ + "img/txmn.430984b7.png";